module.exports = __webpack_public_path__ + "static/logo-fpu-verticle-5abab8438f14374747bd5943ba7864c3.svg";